import * as React from 'react';
import { IOWCOpenDmrContextColors, OWCOpenDmrContext } from "src/context/OWCOpenDmrContext"

export const useColors = (type: keyof IOWCOpenDmrContextColors = 'default') => {
  const context = React.useContext(OWCOpenDmrContext);
  return context.configuration.colors[type];
}